const finish = () => {
    // NProgress.start();
    // eslint-disable-next-line
    NProgress.done();
}

export default finish;